module.exports = __webpack_public_path__ + "product/animation/fav-btn-d94b4a7a38442d582247b0af1943078a.txt";